module.exports = ({
    "CDMS200H001": "No.",
    "CDMS200H002": "รหัสการศึกษา",
    "CDMS200H003": "ชื่อการศึกษา",
    "CDMS200H004": "ตำแหน่ง",
    "CDMS200H005": "Protocol No."
});